// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"057eccd4","977":"c454f428"}[chunkId] + ".chunk.js";
};